import React from 'react'
import { FaExternalLink } from 'react-icons/lib/fa'

const link = "https://facebook.com"

const Facebook = props => {
    return <div className="help__Facebook">
        <h4>Setup Directions</h4>
        <ul>
            <li>Login to Facebook and go to your Timeline: <strong><a target="_blank" href={link}>{link} <FaExternalLink/></a></strong></li>
            <li>In the <strong>What's On Your Mind</strong> widget, select <strong>Live Video</strong> from the More/&hellip; submenu</li>
            <li>Click on <strong>Go Live</strong></li>
            <li>Click on the <strong>Streaming Software</strong> option</li>
            <li>Copy the <strong>Server URL</strong> and <strong>Stream Key</strong> shown and paste them into the text fields above</li>
            <li>Click <strong>Add Social Stream to Event</strong> below</li>
        </ul>
    </div>
}

export default Facebook